import React from "react";

interface KxdAnalyticsIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const KxdAnalyticsIcon: React.FC<KxdAnalyticsIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M18.3333 0C18.7754 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22464 20 1.66667V18.3333C20 18.7754 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.7754 20 18.3333 20H1.66667C1.22464 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.7754 0 18.3333V1.66667C0 1.22464 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22464 0 1.66667 0H18.3333ZM5.15842 10.8735C4.76407 10.8736 4.44444 11.1931 4.44444 11.5875V13.7305C4.44461 14.1247 4.76418 14.4443 5.15842 14.4444H6.58746C6.98177 14.4444 7.30126 14.1248 7.30143 13.7305V11.5875C7.30143 11.193 6.98187 10.8736 6.58746 10.8735H5.15842ZM8.73047 8.01541C8.33598 8.01541 8.01541 8.33598 8.01541 8.73047V13.7305C8.01557 14.1248 8.33608 14.4444 8.73047 14.4444H10.1584C10.5528 14.4444 10.8733 14.1248 10.8735 13.7305V8.73047C10.8735 8.33598 10.5529 8.01541 10.1584 8.01541H8.73047ZM12.3014 4.44444C11.9071 4.44453 11.5876 4.76413 11.5875 5.15842V13.7305C11.5876 14.1248 11.9071 14.4444 12.3014 14.4444H13.7305C14.1247 14.4443 14.4443 14.1247 14.4444 13.7305V5.15842C14.4443 4.76418 14.1247 4.44461 13.7305 4.44444H12.3014Z" fill="#002366"/>
    </svg>
  );
};

export default KxdAnalyticsIcon;
